import { getEditLocation } from "../../../core/util/functions";

export const currencyLocation = "/listing/codebook/currencies";
export const getCurrencyEditLocation = (id?: string) => getEditLocation(currencyLocation, undefined, id);

export const editRouter = getCurrencyEditLocation(":currencyId?");
